import script from "./CustomEdge.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomEdge.vue?vue&type=script&setup=true&lang=ts"

import "./CustomEdge.vue?vue&type=style&index=0&id=79e96f0b&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79e96f0b"]])

export default __exports__